import { Loading, useWindowTitle } from '@cibo/profile'
import { useProgram } from '@cibo/programs'
import { Markdown, PolyBackgroundWithTheme } from '@cibo/ui'
import { Box, Container, Stack } from '@mui/material'
import {
  Headline,
  PaymentSchedule,
  Qualifications,
  ValueProps,
} from 'pages/ProgramDetails/contentBlocks'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

export const ProgramAbout = () => {
  const { t } = useTranslation('impact/pages/ProgramAbout')
  const { programId = '' } = useParams<{ programId: string }>()
  const program = useProgram({ programId })
  useWindowTitle(
    t('windowTitle', {
      context: !!program.data?.content.fields.title ? 'specific' : 'generic',
      programName: program.data?.content.fields.title,
    })
  )

  if (program.isLoading) {
    return <Loading />
  }

  if (!program.data?.content) {
    return null
  }

  return (
    <Stack data-testid="program-description" spacing={6} pb={16}>
      <Stack>
        {program.data.enrollmentWindow.enrollmentStatus === 'closed' &&
          program.data.content.fields.enrollmentClosedDescription && (
            <Box pb={6}>
              <Markdown>{program.data.content.fields.enrollmentClosedDescription}</Markdown>
            </Box>
          )}
        {program.data.enrollmentWindow.enrollmentStatus === 'future' &&
          program.data.content.fields.enrollmentUpcomingDescription && (
            <Box pb={6}>
              <Markdown>{program.data.content.fields.enrollmentUpcomingDescription}</Markdown>
            </Box>
          )}
        <Headline programId={programId} />
      </Stack>
      {!!program.data?.content.fields.valueProps && (
        <Box>
          <PolyBackgroundWithTheme>
            <Container>
              <Box py={6}>
                <ValueProps program={program.data?.content} />
              </Box>
            </Container>
          </PolyBackgroundWithTheme>
        </Box>
      )}
      <Box>
        <Container>
          <PaymentSchedule program={program.data?.content} />
        </Container>
      </Box>
      <Box>
        <Container>
          <Qualifications program={program.data?.content} />
        </Container>
      </Box>
    </Stack>
  )
}
